import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { retrieveFromLocalStorage } from '../../../utils/util';

import {
  requestCreateSupportMessage,
  requestViewAllSupportChats,
  requestViewChat,
} from '../../../api/chat/chat.actions';
import { requestAcknowledgeNotificationsForChat } from '../../../api/notification/notification.actions';

import { setChat } from '../../../slices/chat/chat.slice';

import Support from '../../../components/screens/admin/support/Support';

const SupportContainer = () => {
  const { chat } = useSelector(({ chat }) => chat);
  const { supportChats } = useSelector(({ helpCenter }) => helpCenter);
  const { events } = useSelector(({ event }) => event);

  const { activeChatExternalReference } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestViewAllSupportChats({ showSpinner: true }));

    return () => {
      dispatch(setChat(undefined));
    };
  }, [dispatch]);

  useEffect(() => {
    if (!activeChatExternalReference) return;

    const personExternalReference = retrieveFromLocalStorage('personExternalReference');

    dispatch(
      requestViewChat({
        chatExternalReference: activeChatExternalReference,
        showSpinner: true,
        personExternalReference,
      })
    );

    if (activeChatExternalReference) {
      dispatch(
        requestAcknowledgeNotificationsForChat({
          chatExternalReference: activeChatExternalReference,
        })
      );
    }
  }, [dispatch, activeChatExternalReference]);

  useEffect(() => {
    if (!events || events.length === 0) return;

    let event = events.find((event) => event.type === 'Support Message');
    if (event) {
      dispatch(requestViewAllSupportChats({ showSpinner: false }));
    }

    event = events.find((event) => event.domainObjectExternalReference === activeChatExternalReference);
    if (event) {
      const personExternalReference = retrieveFromLocalStorage('personExternalReference');
      dispatch(
        requestViewChat({
          chatExternalReference: activeChatExternalReference,
          showSpinner: false,
          personExternalReference,
        })
      );
    }
  }, [dispatch, activeChatExternalReference, events]);

  const sendMessage = async (text, onSuccess, onError) => {
    const personExternalReference = retrieveFromLocalStorage('personExternalReference');

    dispatch(
      requestCreateSupportMessage({
        input: {
          message: text,
          chatExternalReference: activeChatExternalReference,
          personExternalReference,
        },
        admin: true,
        onSuccess,
        onError,
      })
    );
  };

  return <Support chats={supportChats} activeChat={chat} sendMessage={sendMessage} />;
};

export default SupportContainer;
